import React from 'react';
import { PropTypes } from 'prop-types';

const CountryFlag = ({ countryCode }) => (
  <i className={`flag-icon flag-icon-${countryCode.toLowerCase()} h4 mb-0`} title={countryCode.toUpperCase()} />
);

CountryFlag.propTypes = {
  countryCode: PropTypes.string.isRequired,
};

export { CountryFlag };
